// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__ESwdQ","fullScreen":"style_fullScreen__vQRvi","hidden":"style_hidden__sueqW"};